export class ResponsiveIframeContent {
  protected static defaultContent = `<!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <base target="_blank" />

    <style>
      html, body {
        margin: 0;
        padding: 0;
        overflow: hidden;
      }

      body {
        word-break: break-word;
        overflow-wrap: anywhere;
        font-family: Arial, Helvetica, sans-serif;
      }

      img {
        max-width: 100%;
        height: auto;
        display: inline-block;
      }

      table {
        max-width: 100%;
        width: 100%;
        border-collapse: collapse;
      }

      * {
        box-sizing: border-box;
      }
    </style>
  </head>
  <body>
    %%CONTENT%%
  </body>
</html>`;

  static getIframeContentTemplate(content: string): string {
    return this.defaultContent.replace('%%CONTENT%%', content);
  }
}
